exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ModelPortfolio__cardHolder{margin:0 25px}.ModelPortfolio__donut_table_Holder__donut{margin-top:5px}.ModelPortfolio .slick-next::before{content:none}.ModelPortfolio .slick-prev::before{content:none}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/sass-loader/dist/cjs.js!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/components/pages/Create_portfolio_by_Advisor/model_portfolio/ModelPortfolio.style.scss
// module id = 1656
// module chunks = 0